module.exports = __webpack_public_path__ + "img/banner_2_en.248fc474.png";